import './Dashboard.scss';

import React, {useEffect, useState} from 'react';
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import ClubSelectorDropdown from "../../../components/dropdown/clubselector/ClubSelectorDropdown";
import {LeaderboardResource, LeaderboardService} from "../../../services/api/LeaderboardService";
import Avatar from "../../../components/Avatar";
import StarIcon from "../../../icons/StarIcon";
import {IconSize} from "../../../services/IconConstants";
import CircleFilledIcon from "../../../icons/CircleIcon";
import {Spinner} from "react-bootstrap";
import RefreshIcon from "../../../icons/RefreshIcon";
import ErrorText from "../../../components/ErrorText";
import LiveReviewFeed from "../../../components/liveReviewFeed/LiveReviewFeed";

interface Props {
}

const Dashboard = ({}: Props) => {

    const { selectedClub } = handicaddieSelector((state) => state.clubs)
    const { user } = handicaddieSelector((state) => state.session)

    const [leaderboard, setLeaderboard] = useState<LeaderboardResource>();
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>();

    useEffect(() => {
        setErrorMsg(undefined)
        loadLeaderboard()
    }, [selectedClub])

    const loadLeaderboard = async () => {
        if (!selectedClub || loading) return;

        setLoading(true);
        let resp = await LeaderboardService().getLeaderboard(selectedClub.id);
        setLoading(false);
        if (resp.error) {
            setLeaderboard(undefined)
            setErrorMsg(resp.error.message);
            return;
        }

        setLeaderboard(resp.leaderboard)
    }

    return (
        <div>
            <div className={"hc-page"}>
                <div className={"dashboard-heading-container"}>
                    <div>
                    <span className={"dashboard-welcome-text"}>
                        WELCOME BACK{user ? `, ${user.firstName}` : ''}
                    </span>
                        <br/>
                        <span>Track how your caddies are performing on the course.</span>
                    </div>
                    <div className={"dashboard-welcome-club-dropdown-container"}>
                        <ClubSelectorDropdown/>
                    </div>
                </div>

                <div className={"dashboard-content-container"}>
                    <div className={"dashboard-leaderboard-container"}>
                        <div className={"dashboard-leaderboard-heading-container"}>
                            <h6>Your Caddie Leaderboard</h6>
                            <div onClick={loadLeaderboard}>
                                {!loading && <RefreshIcon size={IconSize.md} />}
                                {loading && <RefreshIcon size={IconSize.md} className={"dashboard-leaderboard-heading-refreshing-icon"} />}
                            </div>
                        </div>

                        <p>This is your caddies ranked based on their reviews over the last 30 days.</p>
                        <table>
                            <thead>
                            <tr>
                                <td>Caddie</td>
                                <td>Rating</td>
                            </tr>
                            </thead>
                            <tbody>
                            {errorMsg && <ErrorText>{errorMsg}</ErrorText>}
                            {loading && <Spinner animation={"border"}/>}
                            {!leaderboard || leaderboard.rows.length === 0 && <tr>
                                <td>Table not loaded.</td>
                            </tr>}
                            {leaderboard && leaderboard.rows.map((row, idx) => {
                                return (
                                    <tr className={"dashboard-leaderboard-row"} key={idx}>
                                        <td>
                                            <div className={"dashboard-leaderboard-caddie-container"}>
                                                <div>
                                                    <Avatar size={'xsm'} user={row.user.id}/>
                                                </div>
                                                <div className={"dashboard-leaderboard-caddie-information-container"}>
                                                        <span className={"dashboard-leaderboard-caddie-name"}>
                                                            {row.user.displayName}
                                                        </span>
                                                    <br/>
                                                    <div>
                                                        <span>{row.reviewCount} Reviews</span>
                                                        <CircleFilledIcon size={IconSize.xxs}/>
                                                        <span>{row.roundCount} Rounds </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className={"dashboard-leaderboard-caddie-rating-container"}>
                                            {[...Array(5)].map((_, idx) => {
                                                return <StarIcon
                                                    key={idx}
                                                    size={IconSize.sm}
                                                    active={row.overallRating > 0 && row.overallRating >= (idx + 1)}
                                                />
                                            })}
                                            <span>({row.overallRating.toFixed(1)})</span>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>

                    <LiveReviewFeed />
                </div>
            </div>
        </div>
    )
}

export default Dashboard;